export default __webpack_public_path__ + "static/media/ico_advancedAnalytics.fdf7e4e2.svg";